<div class="chart-mode-tabs" role="group" aria-label="Mode d'affichage">
  @for (m of modes; track m) {
    <button class="chart-mode-tab"
            [class.active]="mode === m"
            (click)="changerMode(m)">{{ labels[m] }}</button>
  }
</div>
<div class="chart-nav-wrapper">
  <div class="chart-nav">
    <button class="chart-nav-btn" (click)="reculer()" aria-label="Période précédente">
      <span class="material-symbols-outlined">chevron_left</span>
    </button>
    <button class="chart-nav-label" (click)="ouvrirFermerPicker($event)" aria-label="Choisir la période">
      {{ labelPeriode }}
    </button>
    <button class="chart-nav-btn" (click)="avancer()" [disabled]="!peutAvancer" aria-label="Période suivante">
      <span class="material-symbols-outlined">chevron_right</span>
    </button>
  </div>

  @if (pickerOuvert) {
    <div class="chart-picker" (click)="stopPropagation($event)">
      <div class="chart-picker-header">
        <button class="chart-picker-nav" (click)="pickerReculer($event)" aria-label="Précédent">
          <span class="material-symbols-outlined">chevron_left</span>
        </button>
        <span class="chart-picker-titre">{{ titrePicker }}</span>
        <button class="chart-picker-nav" (click)="pickerAvancer($event)" [disabled]="!peutAvancerPicker" aria-label="Suivant">
          <span class="material-symbols-outlined">chevron_right</span>
        </button>
      </div>

      @if (mode === 'jour') {
        <div class="chart-picker-jours-semaine">
          @for (j of joursSemaine; track $index) {
            <span>{{ j }}</span>
          }
        </div>
      }

      <div class="chart-picker-grid chart-picker-grid--{{ mode }}">
        @for (ligne of lignesPicker; track $index) {
          @for (cellule of ligne; track $index) {
            <button
              class="chart-picker-cellule"
              [class.active]="cellule.actif"
              [class.disabled]="cellule.desactive"
              [class.hors-plage]="cellule.horsPlage"
              [disabled]="cellule.desactive"
              (click)="selectionnerCellule($event, cellule)"
            >{{ cellule.label }}</button>
          }
        }
      </div>
    </div>
  }
</div>
